import Breadcrumbs from 'shared/ui/Breadcrumbs'
import { PATHS } from 'shared/utils/paths'

import { SectionContainer } from '../landings/styles'

const FaqBreadcrumbs = () => {
  return (
    <SectionContainer as='div'>
      <Breadcrumbs
        breadcrumbs={[
          { label: 'Strona główna', path: PATHS.home },
          { label: 'FAQ', path: PATHS.faq }
        ]}
      />
    </SectionContainer>
  )
}

export default FaqBreadcrumbs
